/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation DownloadProductNoticeMutation($input: DownloadProductNotice_M_simulation_productInput!) {
    downloadProductNotice_M_simulation_product(input: $input) {
      ok
      error
      
        url 
    }
  }
`;

export default mutation;
